import { setNotifications } from '../../../store/actions/notificationActions';
import { clearMessage, setMessage } from '../../../store/actions/dialogActions';
import { authLogout } from '../../../store/actions/authActions';
import { getAllPrnd } from "./getAllPrnd";
import API from "../../../store/api";
import { clearPrnd } from "../../../store/actions/prndActions";

export const deletePrnd = (id, bearerAuth, formFunction) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.delete(`/api/portal/prnd/${id}`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status === 200 || res.status === 401)
      .then((response) => {
        if (response.status === 200) {
          dispatch(clearMessage)
          dispatch(getAllPrnd(bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully deleted.'
          }))
          formFunction()
        } else if (response.status === 401) {
          dispatch(clearPrnd);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          }
        }
        dispatch(setMessage({
          title: 'Delete PRND Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}